module.exports = "/images/arrow-gray.png?1504c56cc426a01043a374ce09f32706";